import { Directive, EventEmitter, HostListener, Inject, Input, OnDestroy, Optional, Output } from '@angular/core'
import { MAT_MENU_PANEL, MatMenuPanel } from '@angular/material/menu'
import { filter, Subject, take } from 'rxjs'

import { ConfirmService } from '../services/confirm.service'

@Directive({
  selector: '[mmxConfirmClick]',
  standalone: false,
})
export class ConfirmClickDirective implements OnDestroy {
  @Input()
  public message: string = 'common.are-you-sure'

  @Input()
  public confirmDisabled = false

  @Input()
  public html = false

  @Output()
  public confirm = new EventEmitter<void>()

  private onDestroy$ = new Subject<void>()

  constructor(
    private appConfirmSvc: ConfirmService,
    @Optional() @Inject(MAT_MENU_PANEL) private menuPanel?: MatMenuPanel<unknown>,
  ) { }

  public ngOnDestroy() {
    this.onDestroy$.next()
    this.onDestroy$.complete()
  }

  @HostListener('click', ['$event'])
  public onClick(e: PointerEvent) {
    e.preventDefault()
    e.stopPropagation()

    if (this.confirmDisabled) {
      this.confirm.emit()
      this.menuPanel?.close?.emit('click')
      return
    }

    this.appConfirmSvc.confirm({
      message: this.message,
      html: this.html,
    })
      .pipe(
        take(1),
        filter((confirm) => confirm),
      )
      .subscribe(() => {
        this.confirm.emit()
        this.menuPanel?.close?.emit('click')
      })
  }
}
